export default __webpack_public_path__ + "assets/models/2380bc4708ddab780b096595eb6aa45e.glb";